import React from 'react';
import moment from 'moment';
import { observation } from '../../libs/api';
import { CircularProgress } from 'material-ui';
import GraphView from '../GraphView';
import _ from 'lodash';
import { getDisplayDate } from "../../libs/date";

class ObservationWaterLevel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      observations: null,
      data: {
        data: [],
        categories: [],
        seriesData: [],
      },
      titleText: '',
      options: null
    };
  }

  componentWillMount() {
    let { series_id, date, period } = this.props;
    this.onView(series_id, date, period);
  };
  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      let { series_id, date, period } = nextProps;
      this.onView(series_id, date, period);
    }
  };

  onView = (series_id, date, periodFilter) => {

    this.setState({ loading: true });
    date = moment(date).format('YYYY-MM-DD');

    let date_from = periodFilter === 'Daily' ? moment(date).subtract(6, 'days').format('YYYY-MM-DD') : date;

    observation(series_id, date_from, date)
      .then(observations => {

        const titleText = `${observations.parameter_name} from ${date} to ${date}`;
        const dataState = this.state.data;
        // observations.data[0].value = null;

        dataState.data = (
          observations.data && observations.data.map(observation => !!observation.value ? +parseFloat(observation.value) : observation.value)
        ) || [];
        dataState.categories = (
          observations.data && observations.data.map(observation => observation.datetime)
        ) || [];

        const seriesData = (
          observations.data &&
          observations.data.map(({ datetime, value }) => {
            return [getDisplayDate(datetime, { returnMills: true }), value];
          })
        ) || [];

        let seriesOptions;

        if (periodFilter === 'Point') {
          seriesOptions = [{
            name: 'Point',
            data: seriesData,
          }];
        } else {
          const resolvePeriodFormat = p => {
            switch (p) {
              // case 'Point': return 'YYYY-MM-DDTHH:mm:ss+00:00';
              case 'Minute':
                return 'YYYY-MM-DDTHH:mm:00+00:00';
              case 'Hourly':
                return 'YYYY-MM-DDTHH:00:00+00:00';
              case 'Daily':
                return 'YYYY-MM-DDT00:00:00+00:00';
              case 'Weekly':
                return 'YYYY-MM-DDT00:00:00+00:00';
              // case 'Weekly':  return 'YYYY-MM-DDTHH:00:00+00:00';
              // case 'Weekly': return 'gggg ww';
              case 'Monthly':
                return 'YYYY-MM-01T00:00:00+00:00';
              case 'Annual':
                return 'YYYY-01-01T00:00:00+00:00';
              default:
                return 'YYYY-MM-DDTHH:mm:ss+00:00';
            }
          };
          const periodFormat = resolvePeriodFormat(periodFilter);
          const seriesDataPeriodic = _.groupBy(seriesData, item => moment.utc(item[0]).format(periodFormat));
          const max = {}, min = {}, mean = {};

          Object.keys(seriesDataPeriodic)
            .forEach(period => {
              const periodData = seriesDataPeriodic[period].map(item => item[1]).filter(item => !!item || item === 0);
              max[period] = _.max(periodData);
              min[period] = _.min(periodData);
              mean[period] = _.mean(periodData);
            });

          const maxSeries = Object.keys(max).map(period => ([moment.utc(period).valueOf(), max[period]]));
          const minSeries = Object.keys(min).map(period => ([moment.utc(period).valueOf(), min[period]]));
          const meanSeries = Object.keys(mean).map(period => ([moment.utc(period).valueOf(), mean[period]]));

          seriesOptions = [
            {
              name: 'Max',
              data: maxSeries,
            },
            {
              name: 'Min',
              data: minSeries,
            },
            {
              name: 'Average',
              data: meanSeries,
            },
          ];
        }

        let plotLines = [];
        if (this.props.thresholds) {
          if (this.props.thresholds.warning) {
            plotLines.push({
              value: +this.props.thresholds.warning,
              color: 'orange',
              width: 1,
              label: {
                text: 'Warning Level'
              },
              zIndex: 2,
            })
          }
          if (this.props.thresholds.danger) {
            plotLines.push({
              value: +this.props.thresholds.danger,
              color: 'red',
              width: 1,
              label: {
                text: 'Danger Level'
              },
              zIndex: 2,
            })
          }
        }


        const options = {
          chart: {
            type: 'line',
            zoomType: 'x',
          },
          title: {
            text: null
          },
          xAxis: {
            type: 'datetime',
            dateTimeLabelFormats: {
              millisecond: '%H:%M:%S.%L',
              second: '%H:%M:%S',
              minute: '%H:%M',
              hour: '%H:%M',
              day: '%e. %b',
              week: '%e. %b',
              month: '%b \'%y',
              year: '%Y',
            },
          },
          yAxis: {
            title: {
              text: 'm',
            },
            // min:0,
            // max:10,
            plotLines
          },
          tooltip: {
            shared: true,
            valueDecimals: 3
          },
          series: seriesOptions,
          credits: {
            enabled: false
          },
        };

        this.setState({
          data: dataState,
          titleText,
          seriesData,
          options,
          loading: false,
          observations: seriesOptions
        });
      })
  };

  render() {

    const roundOff = value => Math.round(value * 100) / 100;
    let width = this.props.mobView ? '100%' : '50%';
    if (!this.props.series_id) return (<div></div>);

    return (
      <div className={this.props.mobView ? 'column-it' : 'inline-it'}>
        {!this.state.loading && this.state.observations ?
          <div className="observation-table" style={{ width }}>{
            <table className="table tab-bar">
              <thead>
                <tr>
                  <th>Date</th>
                  {this.state.observations.map((period, thi) => (<th key={thi}>{period.name}</th>))}</tr>
              </thead>
              <tbody>{
                this.state.observations[0].data.map((data, tri) => (
                  <tr key={tri}>
                    <td>{moment.utc(data['0']).format('llll')}</td>
                    {
                      this.state.observations.map((period, tdi) => (
                        <td key={tdi}>{roundOff(period.data.filter(d => d['0'] === data['0'])[0]['1'])}</td>
                      ))
                    }</tr>
                ))
              }</tbody>
            </table>
          }</div> :
          <div className="spinner"><CircularProgress /></div>}
        {!this.state.loading && this.state.options && <GraphView style={{ width }} options={this.state.options} />}
      </div>
    );
  }
}

export default ObservationWaterLevel;


// WEBPACK FOOTER //
// ./src/components/Station/ObservationWaterLevel.js